/** @typedef {String} PathifiedSvgContent */
/** @typedef {String} FeatherIconsPathDefinition */
/** @typedef {{ prefix: 'fe', iconName: 'feCodepen', icon: [Number|String, Number|String, import('feather-icons').FeatherAttributes, PathifiedSvgContent, FeatherIconsPathDefinition] }} FeatherCodepenIconData */

/** @type {FeatherCodepenIconData} */
const feCodepen = {
  prefix: 'fe',
  iconName: 'codepen',
  icon: [
    24,
    24,
    '<polygon points="12 2 22 8.5 22 15.5 12 22 2 15.5 2 8.5 12 2"></polygon><line x1="12" y1="22" x2="12" y2="15.5"></line><polyline points="22 8.5 12 15.5 2 8.5"></polyline><polyline points="2 15.5 12 8.5 22 15.5"></polyline><line x1="12" y1="2" x2="12" y2="8.5"></line>',
    '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-codepen"><path d="M12 2 L22 8.5 L22 15.5 L12 22 L2 15.5 L2 8.5 L12 2 Z"/><path d="M12 22 L12 15.5"/><path d="M22 8.5 L12 15.5 L2 8.5"/><path d="M2 15.5 L12 8.5 L22 15.5"/><path d="M12 2 L12 8.5"/></svg>',
    'M12 2 L22 8.5 L22 15.5 L12 22 L2 15.5 L2 8.5 L12 2 Z M12 22 L12 15.5 M22 8.5 L12 15.5 L2 8.5 M2 15.5 L12 8.5 L22 15.5 M12 2 L12 8.5',
    '"xmlns"="http=//www.w3.org/2000/svg" "width"="24" "height"="24" "fill"="none" "stroke"="currentColor" "stroke-width"=2 "stroke-linecap"="round" "stroke-linejoin"="round"',
    {
      xmlns: 'http://www.w3.org/2000/svg',
      width: 24,
      height: 24,
      fill: 'none',
      stroke: 'currentColor',
      'stroke-width': 2,
      'stroke-linecap': 'round',
      'stroke-linejoin': 'round',
    },
  ],
}

export default feCodepen
